/* tslint:disable */
/* eslint-disable */
/**
 * RX360-WebAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FileSchemaIn } from './FileSchemaIn';
import {
    FileSchemaInFromJSON,
    FileSchemaInFromJSONTyped,
    FileSchemaInToJSON,
} from './FileSchemaIn';

/**
 * 
 * @export
 * @interface NationalIdPhoto
 */
export interface NationalIdPhoto {
    /**
     * 
     * @type {FileSchemaIn}
     * @memberof NationalIdPhoto
     */
    nationalIdFront?: FileSchemaIn;
    /**
     * 
     * @type {FileSchemaIn}
     * @memberof NationalIdPhoto
     */
    nationalIdBack?: FileSchemaIn;
}

/**
 * Check if a given object implements the NationalIdPhoto interface.
 */
export function instanceOfNationalIdPhoto(value: object): boolean {
    return true;
}

export function NationalIdPhotoFromJSON(json: any): NationalIdPhoto {
    return NationalIdPhotoFromJSONTyped(json, false);
}

export function NationalIdPhotoFromJSONTyped(json: any, ignoreDiscriminator: boolean): NationalIdPhoto {
    if (json == null) {
        return json;
    }
    return {
        
        'nationalIdFront': json['national_id_front'] == null ? undefined : FileSchemaInFromJSON(json['national_id_front']),
        'nationalIdBack': json['national_id_back'] == null ? undefined : FileSchemaInFromJSON(json['national_id_back']),
    };
}

export function NationalIdPhotoToJSON(value?: NationalIdPhoto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'national_id_front': FileSchemaInToJSON(value['nationalIdFront']),
        'national_id_back': FileSchemaInToJSON(value['nationalIdBack']),
    };
}

